export default __webpack_public_path__ + "static/media/Vending2.7beaef01.png";